import * as React from 'react';

const ScreenSmallChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 18h2v-2h-2v2zm-2-4h6V6H9v8zM7 4v16h10V4H7z"
        />
    </svg>
);

ScreenSmallChunkySvg.displayName = 'ScreenSmallChunkySvg';
export default ScreenSmallChunkySvg;
